export function blockNumberToHour(blockNumber) {
    return blockNumber + 6;
}


// WEBPACK FOOTER //
// ./src/util/convertFunctions.js